import React from 'react'
import { DownloadIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'

import { useExportPricingCampaignsSettingsMutation } from '@/entities/pricing-campaign'

import { Button } from '@/shared/components/ui/button'
import { Spinner } from '@/shared/components/ui/spinner'

const downloadFromUrl = (url: string) => {
	const a = document.createElement('a')
	a.href = url
	a.setAttribute('download', '')
	document.body.appendChild(a)
	a.click()
	a.remove()
}
export function PricingCampaignExportSettings() {
	const { t } = useTranslation()
	const exportPricingCampaignsSettings =
		useExportPricingCampaignsSettingsMutation({
			onSuccess: ({ url }) => {
				downloadFromUrl(url)
				toast.success(
					t('pc.export.downloading.success', {
						defaultValue: 'Pricing campaigns settings are downloading',
					})
				)
			},
			onError: () => {
				toast.error(
					t('pc.export.downloading.failed', {
						defaultValue:
							'Failed to export pricing campaigns settings, please try again.',
					})
				)
			},
		})

	return (
		<Button
			disabled={exportPricingCampaignsSettings.isPending}
			onClick={() => exportPricingCampaignsSettings.mutate()}
		>
			{exportPricingCampaignsSettings.isPending ? (
				<Spinner />
			) : (
				<DownloadIcon className='size-4' />
			)}
			{t('pc.export.download', {
				defaultValue: 'Export settings',
			})}
		</Button>
	)
}
